import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Admin = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    document.title = "Enquiries — T Plus One Admin";
    axios.get(`${API}/enquiries`).then((r) => setEnquiries(r.data)).catch(() => setError("Could not load enquiries."));
  }, []);

  return (
    <main className="pt-32 lg:pt-40 pb-24 min-h-screen" data-testid="admin-page">
      <div className="container-x">
        <p className="eyebrow">Admin</p>
        <h1 className="mt-4 text-3xl sm:text-4xl tracking-tight">Enquiries</h1>
        <p className="mt-3 text-sm text-dim">{enquiries.length} received</p>
        {error && <p className="mt-6 text-sm text-red-700" role="alert">{error}</p>}
        <div className="mt-10 overflow-x-auto rounded-sm border border-line bg-white">
          <table className="w-full text-left text-sm min-w-[720px]">
            <thead>
              <tr className="border-b border-line">
                {["Date", "Name", "Email", "Phone", "Interest", "Mode", "Message"].map((h) => (
                  <th key={h} className="p-4 eyebrow font-normal">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {enquiries.map((e) => (
                <tr key={e.id} className="border-b border-line last:border-0" data-testid={`enquiry-row-${e.id}`}>
                  <td className="p-4 text-tertiary whitespace-nowrap">{new Date(e.created_at).toLocaleDateString()}</td>
                  <td className="p-4 font-medium">{e.name}</td>
                  <td className="p-4 text-dim">{e.email}</td>
                  <td className="p-4 text-dim">{e.phone}</td>
                  <td className="p-4">{e.interest}</td>
                  <td className="p-4 text-dim">{e.mode || "—"}</td>
                  <td className="p-4 text-dim max-w-xs truncate">{e.message || "—"}</td>
                </tr>
              ))}
              {enquiries.length === 0 && !error && (
                <tr><td colSpan={7} className="p-10 text-center text-dim">No enquiries yet.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </main>
  );
};

export default Admin;
